// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .trusted-section {
    background-color: #ffffff; /* White or neutral section bg */
    padding: 40px 0;
    text-align: center;
  }

  .trusted-heading {
    font-size: 30px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #142254;
  }


.trusted-track-wrapper {
  width: 200%; /* Ensures track scrolls across entire duplicated content */
}
.trusted-slider {
  overflow: hidden;
  position: relative;
  width: 100%;
  background-color: #f0f0f0;
  padding: 2px 0;
}

.trusted-track {
  display: flex;
  width: max-content;
  animation: scroll 25s linear infinite;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-43%);
  }
}



  .trusted-logo {
    height: 70px;
    width: 200px;
    /* padding: 10px; */
    margin: 10px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }

  .trusted-logo:hover {
    transform: translateY(-5px);
  }

  .trusted-logo img {
    max-height: 60px;
    max-width: 70%;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
  .trusted-section {
  background-color: #ffffff;
  /* padding: 60px 0; */
  text-align: center;
}

.trusted-heading {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #142254;
}

.trusted-static {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 15px 0;
  background-color: #f7f9ff;
}

.trusted-static .trusted-logo {
  height: 70px;
  width: 250px;
  margin: 0; /* Remove spacing */
  padding: 0;
  box-shadow: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
 
}

.trusted-static .trusted-logo img {
  max-height: 120px;
  max-width: 89%;
  /* object-fit: contain; */
}

/* Hide scrollbar but allow scroll if needed */
.trusted-static::-webkit-scrollbar {
  display: none;
}
.trusted-static {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Responsive */
@media (max-width: 991px) {
  .trusted-logo {
    width: 160px;
    height: 100px;
  }
  .trusted-logo img {
    max-height: 80px;
  }
}

@media (max-width: 575px) {
  .trusted-logo {
    width: 140px;
    height: 90px;
  }
  .trusted-logo img {
    max-height: 70px;
  }
}




  /* Responsive Styling */
  @media (max-width: 991px) {
    .trusted-heading {
      font-size: 1.5rem;
      margin-bottom: 15px;
    }

    .trusted-logo {
      width: 150px;
      height: 80px;
      padding: 8px;
    }

    .trusted-logo img {
      max-height: 60px;
    }

    .trusted-track {
      animation-duration: 18s;
    }
  }

  @media (max-width: 575px) {
    .trusted-heading {
      font-size: 1.3rem;
      margin-bottom: 12px;
    }

    .trusted-logo {
      width: 120px;
      height: 60px;
      padding: 5px;
    }

    .trusted-logo img {
      max-height: 50px;
    }

    .trusted-track {
      animation-duration: 14s;
    }
  }
/* --- Mobile-Specific Additions --- */

/* Tablets and below */
@media (max-width: 768px) {
  .trusted-static {
    flex-wrap: wrap; /* allow wrapping for static section */
    justify-content: center;
    gap: 10px;
    padding: 10px;
  }

  .trusted-static .trusted-logo {
    width: 140px;
    height: 70px;
    margin: 5px;
  }

  .trusted-static .trusted-logo img {
    max-height: 55px;
    max-width: 80%;
  }

  .trusted-track {
    animation-duration: 18s; /* faster scroll on smaller screen */
  }
}

/* ==================================================
   GLOBAL MOBILE SYSTEM
   SAME FOR ALL PAGES
================================================== */

@media screen and (max-width: 767px) {

  .trusted-section {
    padding: 30px 16px !important;
  }

  /* Same heading size everywhere */
  .trusted-heading,
  h2 {
    font-size: 24px !important;
    line-height: 32px !important;
    font-weight: 700 !important;
    margin-bottom: 24px !important;
  }

  /* Client logos section */
  .trusted-static {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    padding: 0;
    background: transparent;
    overflow: visible;
  }

  .trusted-static .trusted-logo {
    width: 100% !important;
    height: 80px !important;
    margin: 0 !important;
    border-radius: 10px;
    background: #fff;
  }

  .trusted-static .trusted-logo img {
    max-width: 85%;
    max-height: 50px;
    object-fit: contain;
  }

  /* Slider section */

  .trusted-slider {
    margin-top: 10px;
  }

  .trusted-track {
    animation-duration: 15s;
  }

  .trusted-track .trusted-logo {
    width: 140px;
    height: 70px;
    margin: 6px;
  }

  .trusted-track .trusted-logo img {
    max-width: 80%;
    max-height: 45px;
  }

  /* Certificates */

  .certificates-grid {
    grid-template-columns: 1fr !important;
  }

}

/* ==================================================
   SMALL PHONES
================================================== */

@media screen and (max-width: 480px) {

  .trusted-heading,
  h2 {
    font-size: 22px !important;
    line-height: 30px !important;
  }

  .trusted-static {
    gap: 10px;
  }

  .trusted-static .trusted-logo {
    height: 72px !important;
  }

  .trusted-static .trusted-logo img {
    max-height: 42px;
  }

  .trusted-track .trusted-logo {
    width: 120px;
    height: 60px;
  }

  .trusted-track .trusted-logo img {
    max-height: 40px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/TrustedPartners/TrustedPartners.css"],"names":[],"mappings":"EAAE;IACE,yBAAyB,EAAE,gCAAgC;IAC3D,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;EAChB;;;AAGF;EACE,WAAW,EAAE,2DAA2D;AAC1E;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;;;EAIE;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iDAAiD;EACnD;EACA;EACA,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS,EAAE,mBAAmB;EAC9B,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;;AAEd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF;;;;;EAKE,uBAAuB;EACvB;IACE;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,uBAAuB;IACzB;EACF;AACF,sCAAsC;;AAEtC,sBAAsB;AACtB;EACE;IACE,eAAe,EAAE,sCAAsC;IACvD,uBAAuB;IACvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uBAAuB,EAAE,oCAAoC;EAC/D;AACF;;AAEA;;;oDAGoD;;AAEpD;;EAEE;IACE,6BAA6B;EAC/B;;EAEA,iCAAiC;EACjC;;IAEE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA,yBAAyB;EACzB;IACE,wBAAwB;IACxB,qCAAqC;IACrC,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,mBAAmB;;EAEnB;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,iBAAiB;;EAEjB;IACE,qCAAqC;EACvC;;AAEF;;AAEA;;oDAEoD;;AAEpD;;EAEE;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["  .trusted-section {\r\n    background-color: #ffffff; /* White or neutral section bg */\r\n    padding: 40px 0;\r\n    text-align: center;\r\n  }\r\n\r\n  .trusted-heading {\r\n    font-size: 30px;\r\n    font-weight: 700;\r\n    margin-bottom: 20px;\r\n    color: #142254;\r\n  }\r\n\r\n\r\n.trusted-track-wrapper {\r\n  width: 200%; /* Ensures track scrolls across entire duplicated content */\r\n}\r\n.trusted-slider {\r\n  overflow: hidden;\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: #f0f0f0;\r\n  padding: 2px 0;\r\n}\r\n\r\n.trusted-track {\r\n  display: flex;\r\n  width: max-content;\r\n  animation: scroll 25s linear infinite;\r\n}\r\n\r\n@keyframes scroll {\r\n  0% {\r\n    transform: translateX(0);\r\n  }\r\n  100% {\r\n    transform: translateX(-43%);\r\n  }\r\n}\r\n\r\n\r\n\r\n  .trusted-logo {\r\n    height: 70px;\r\n    width: 200px;\r\n    /* padding: 10px; */\r\n    margin: 10px;\r\n    background-color: #ffffff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: transform 0.3s ease;\r\n  }\r\n\r\n  .trusted-logo:hover {\r\n    transform: translateY(-5px);\r\n  }\r\n\r\n  .trusted-logo img {\r\n    max-height: 60px;\r\n    max-width: 70%;\r\n    object-fit: contain;\r\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n  }\r\n  .trusted-section {\r\n  background-color: #ffffff;\r\n  /* padding: 60px 0; */\r\n  text-align: center;\r\n}\r\n\r\n.trusted-heading {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  margin-bottom: 30px;\r\n  color: #142254;\r\n}\r\n\r\n.trusted-static {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: nowrap;\r\n  overflow-x: auto;\r\n  padding: 15px 0;\r\n  background-color: #f7f9ff;\r\n}\r\n\r\n.trusted-static .trusted-logo {\r\n  height: 70px;\r\n  width: 250px;\r\n  margin: 0; /* Remove spacing */\r\n  padding: 0;\r\n  box-shadow: none;\r\n  background-color: transparent;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: none;\r\n \r\n}\r\n\r\n.trusted-static .trusted-logo img {\r\n  max-height: 120px;\r\n  max-width: 89%;\r\n  /* object-fit: contain; */\r\n}\r\n\r\n/* Hide scrollbar but allow scroll if needed */\r\n.trusted-static::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n.trusted-static {\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 991px) {\r\n  .trusted-logo {\r\n    width: 160px;\r\n    height: 100px;\r\n  }\r\n  .trusted-logo img {\r\n    max-height: 80px;\r\n  }\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .trusted-logo {\r\n    width: 140px;\r\n    height: 90px;\r\n  }\r\n  .trusted-logo img {\r\n    max-height: 70px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n  /* Responsive Styling */\r\n  @media (max-width: 991px) {\r\n    .trusted-heading {\r\n      font-size: 1.5rem;\r\n      margin-bottom: 15px;\r\n    }\r\n\r\n    .trusted-logo {\r\n      width: 150px;\r\n      height: 80px;\r\n      padding: 8px;\r\n    }\r\n\r\n    .trusted-logo img {\r\n      max-height: 60px;\r\n    }\r\n\r\n    .trusted-track {\r\n      animation-duration: 18s;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 575px) {\r\n    .trusted-heading {\r\n      font-size: 1.3rem;\r\n      margin-bottom: 12px;\r\n    }\r\n\r\n    .trusted-logo {\r\n      width: 120px;\r\n      height: 60px;\r\n      padding: 5px;\r\n    }\r\n\r\n    .trusted-logo img {\r\n      max-height: 50px;\r\n    }\r\n\r\n    .trusted-track {\r\n      animation-duration: 14s;\r\n    }\r\n  }\r\n/* --- Mobile-Specific Additions --- */\r\n\r\n/* Tablets and below */\r\n@media (max-width: 768px) {\r\n  .trusted-static {\r\n    flex-wrap: wrap; /* allow wrapping for static section */\r\n    justify-content: center;\r\n    gap: 10px;\r\n    padding: 10px;\r\n  }\r\n\r\n  .trusted-static .trusted-logo {\r\n    width: 140px;\r\n    height: 70px;\r\n    margin: 5px;\r\n  }\r\n\r\n  .trusted-static .trusted-logo img {\r\n    max-height: 55px;\r\n    max-width: 80%;\r\n  }\r\n\r\n  .trusted-track {\r\n    animation-duration: 18s; /* faster scroll on smaller screen */\r\n  }\r\n}\r\n\r\n/* ==================================================\r\n   GLOBAL MOBILE SYSTEM\r\n   SAME FOR ALL PAGES\r\n================================================== */\r\n\r\n@media screen and (max-width: 767px) {\r\n\r\n  .trusted-section {\r\n    padding: 30px 16px !important;\r\n  }\r\n\r\n  /* Same heading size everywhere */\r\n  .trusted-heading,\r\n  h2 {\r\n    font-size: 24px !important;\r\n    line-height: 32px !important;\r\n    font-weight: 700 !important;\r\n    margin-bottom: 24px !important;\r\n  }\r\n\r\n  /* Client logos section */\r\n  .trusted-static {\r\n    display: grid !important;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 12px;\r\n    padding: 0;\r\n    background: transparent;\r\n    overflow: visible;\r\n  }\r\n\r\n  .trusted-static .trusted-logo {\r\n    width: 100% !important;\r\n    height: 80px !important;\r\n    margin: 0 !important;\r\n    border-radius: 10px;\r\n    background: #fff;\r\n  }\r\n\r\n  .trusted-static .trusted-logo img {\r\n    max-width: 85%;\r\n    max-height: 50px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  /* Slider section */\r\n\r\n  .trusted-slider {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .trusted-track {\r\n    animation-duration: 15s;\r\n  }\r\n\r\n  .trusted-track .trusted-logo {\r\n    width: 140px;\r\n    height: 70px;\r\n    margin: 6px;\r\n  }\r\n\r\n  .trusted-track .trusted-logo img {\r\n    max-width: 80%;\r\n    max-height: 45px;\r\n  }\r\n\r\n  /* Certificates */\r\n\r\n  .certificates-grid {\r\n    grid-template-columns: 1fr !important;\r\n  }\r\n\r\n}\r\n\r\n/* ==================================================\r\n   SMALL PHONES\r\n================================================== */\r\n\r\n@media screen and (max-width: 480px) {\r\n\r\n  .trusted-heading,\r\n  h2 {\r\n    font-size: 22px !important;\r\n    line-height: 30px !important;\r\n  }\r\n\r\n  .trusted-static {\r\n    gap: 10px;\r\n  }\r\n\r\n  .trusted-static .trusted-logo {\r\n    height: 72px !important;\r\n  }\r\n\r\n  .trusted-static .trusted-logo img {\r\n    max-height: 42px;\r\n  }\r\n\r\n  .trusted-track .trusted-logo {\r\n    width: 120px;\r\n    height: 60px;\r\n  }\r\n\r\n  .trusted-track .trusted-logo img {\r\n    max-height: 40px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
